import React from 'react';

const DateRangeSelector = ({ 
    dateRangeType, 
    onDateRangeTypeChange, 
    dateFrom, 
    onDateFromChange, 
    dateTo, 
    onDateToChange 
}) => {
    return (
        <div style={{ marginTop: '12px', display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
            <label htmlFor="dateRangeType" style={{ fontWeight: '500' }}>
                Date Range Type:
            </label>
            <select
                id="dateRangeType"
                value={dateRangeType}
                onChange={(e) => onDateRangeTypeChange(e.target.value)}
                style={{
                    padding: '6px 12px',
                    borderRadius: '4px',
                    border: '1px solid #ced4da',
                    fontSize: '14px',
                    minWidth: '150px'
                }}
            >
                <option value="last_period">Last Period</option>
                <option value="this_period">This Period</option>
                <option value="latest_first_week">Latest First Week</option>
                <option value="range">Date Range</option>
            </select>
            {dateRangeType === "range" && (
                <>
                    <label htmlFor="dateFrom" style={{ fontWeight: '500', marginLeft: '12px' }}>
                        From:
                    </label>
                    <input
                        id="dateFrom"
                        type="date"
                        value={dateFrom}
                        onChange={(e) => onDateFromChange(e.target.value)}
                        style={{
                            padding: '6px 12px',
                            borderRadius: '4px',
                            border: '1px solid #ced4da',
                            fontSize: '14px'
                        }}
                    />
                    <label htmlFor="dateTo" style={{ fontWeight: '500' }}>
                        To:
                    </label>
                    <input
                        id="dateTo"
                        type="date"
                        value={dateTo}
                        onChange={(e) => onDateToChange(e.target.value)}
                        style={{
                            padding: '6px 12px',
                            borderRadius: '4px',
                            border: '1px solid #ced4da',
                            fontSize: '14px'
                        }}
                    />
                </>
            )}
        </div>
    );
};

export default DateRangeSelector;

